import type { Router } from "vue-router";

let _router: Router | null = null;

export function setRouter(router: Router): void {
	_router = router;
}

export function getRouter(): Router {
	if (!_router) {
		throw new Error("routerRef accessed before router was initialised");
	}
	return _router;
}
